var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g(_vm._b({staticClass:"btn",attrs:{"variant":"white"}},'b-button',_vm.$attrs,false),_vm.$listeners),[(_vm.isIcon)?[_c('i',{class:`icon fa fa-${_vm.icon} mr-2`})]:_vm._e(),_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.label))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }